import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { getLanguageSwitcher } from '@seek/ca-myprofile-utils';
import { siteConfig } from '@seek/melways-sites';
import { useLocation } from 'react-router-dom';

import { useConfig } from 'src/context/config';
import { useAuth } from 'src/context/useAuth';
import { useGetProfileAvatar } from 'src/hooks/useGetProfileAvatar';

export const Header = ({ lean = false }) => {
  const { config } = useConfig();
  const { SITE: site } = config;
  const { authenticationStatus, data: user } = useAuth();
  const firstName = user?.viewer?.personalDetails.firstName || '';
  const lastName = user?.viewer?.personalDetails.lastName || '';
  const email = user?.viewer?.emailAddress || '';
  const { languages: siteConfigLanguages } = siteConfig[site];
  const currentUrl = typeof window !== 'undefined' ? location.pathname : '';
  const languagePattern = siteConfigLanguages.join('|');
  const urlWithoutLang = currentUrl.replace(
    new RegExp(`^/(?:(?:${languagePattern})/)?`),
    '',
  );
  const { search } = useLocation();
  const languageSwitcher = getLanguageSwitcher(
    siteConfigLanguages,
    urlWithoutLang,
    search,
  );
  const { profileAvatar } = useGetProfileAvatar();
  const userProfile = {
    firstName,
    lastName,
    email,
    profilePhotoUrl: profileAvatar?.image128Url ?? undefined,
  };

  return (
    <ApacCandidateHeaderFooterLinkProvider value={{ sendLinkEvent: () => {} }}>
      <ApacCandidateHeader
        authenticationStatus={authenticationStatus}
        userProfile={userProfile}
        leanHeader={lean}
        languageSwitcher={languageSwitcher}
        onLanguageSwitch={() => {}}
        widthMode="large"
        divider
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};
